// TODO likely remove entire frontend task api, replace with multi-task api #307
import type { Task } from "../features/task";
import API, { responseOf } from "./base";

export const create = (task: Task): Promise<Task> =>
  responseOf(API.post("/tasks", task));

export const get = (processId: string, taskId: string): Promise<Task> =>
  responseOf(API.get(`/tasks/${taskId}`, { params: { processId } }));

export const update = (task: Task): Promise<Task> =>
  responseOf(API.put(`/tasks/${task.id}`, task));

const remove = async ({ id, process_id: processId }: Task): Promise<void> => {
  await API.delete(`/tasks/${id}`, { params: { processId } });
};
export { remove as delete };

export const move = async (task: Task, processId: string): Promise<void> => {
  await API.put(`/tasks/${task.id}`, {
    ...task,
    root_process_id: processId,
    process_id: processId,
  });
};

export const duplicate = (task: Task): Promise<Task> => {
  const newTask = { ...task, previous_task_id: task.id };
  delete newTask.id;
  delete newTask.created_at;
  return create(newTask);
};
